import React, { useEffect, useState, Fragment } from 'react';
import { CTAButton, CHECKOUT_URL } from './CTAButton';
import { Star, Shield } from 'lucide-react';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/xmjrRoHvrxanNkG8pTnxnx/ChatGPT-Image-20-jun-2026_-22_07_30.webp';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 30,
    seconds: 5
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) seconds--;else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 1;
          minutes = 30;
          seconds = 5;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-7 px-4 sm:px-6 bg-brand-beige border-y-2 border-brand-brown/20 scroll-mt-2" data-id="element-123">
      <div className="text-center mb-4" data-id="element-124">
        <p className="text-xs font-bold text-brand-orange uppercase tracking-widest mb-2" data-id="element-125">
          SPECIAL OFFER — COMPLETE 6-IN-1 PACK
        </p>
        <p className="text-sm font-bold text-brand-ink mb-3 leading-tight" data-id="element-126">
          Access the system now and transform your dog training sessions today.
        </p>
        <div className="inline-block bg-brand-green text-white px-3 py-1 rounded shadow-sm mb-4" data-id="element-127">
          <p className="font-bold text-sm tracking-wide uppercase" data-id="element-128">
            🐾 DOG TRAINER PRO™ — 6-in-1 Complete Box Set
          </p>
        </div>
        <a href={CHECKOUT_URL} className="block cursor-pointer" data-id="element-129">
          <img src={PRODUCT_IMG} alt="Dog Trainer Pro 6-in-1 Complete Box Set" className="w-full max-w-[260px] mx-auto object-contain drop-shadow-xl mb-4 rounded-lg" data-id="element-130" />
        </a>
      </div>

      <div className="bg-white border-4 border-brand-green rounded-lg p-5 text-center relative mb-4 shadow-xl" data-id="element-131">
        <div className="mb-4" data-id="element-132">
          <p className="text-sm font-bold text-brand-ink/60 mb-1" data-id="element-133">
            Normal Price: <span className="line-through" data-id="element-134">$97 USD</span>
          </p>
          <p className="text-base font-black text-brand-orange mb-2 uppercase tracking-wide" data-id="element-135">
            🔥 72% OFF — LAUNCH OFFER
          </p>
          <p className="text-5xl font-heading font-black text-brand-green mb-1 leading-none" data-id="element-136">
            $27 USD
          </p>
          <p className="text-[10px] font-bold text-brand-ink/60 uppercase tracking-wider" data-id="element-137">
            Pay in your local currency
          </p>
        </div>

        <div className="bg-brand-beige border-2 border-brand-orange/40 rounded-md p-3 mb-5" data-id="element-138">
          <p className="text-xs font-bold text-brand-orange mb-2 uppercase tracking-tight" data-id="element-139">
            🔥 Last chance! The price increases when the timer ends.
          </p>
          <div className="flex justify-center gap-2" data-id="element-140">
            {[{
            v: timeLeft.hours,
            l: 'HOURS'
          }, {
            v: timeLeft.minutes,
            l: 'MINUTES'
          }, {
            v: timeLeft.seconds,
            l: 'SECONDS'
          }].map((unit, idx) => <Fragment key={unit.l} data-id="element-141">
                {idx > 0 && <div className="text-xl font-black text-brand-green mt-1" data-id="element-142">
                    :
                  </div>}
                <div className="text-center" data-id="element-143">
                  <div className="bg-brand-green text-white font-heading text-2xl font-black px-2 py-1.5 rounded shadow-inner leading-none min-w-[44px]" data-id="element-144">
                    {String(unit.v).padStart(2, '0')}
                  </div>
                  <p className="text-[9px] font-bold text-brand-ink/70 mt-1 tracking-wider uppercase" data-id="element-145">
                    {unit.l}
                  </p>
                </div>
              </Fragment>)}
          </div>
        </div>

        <CTAButton checkout data-id="element-146">🚀 YES, I WANT THE 6-IN-1 PACK</CTAButton>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-1.5 sm:gap-6 text-xs text-brand-green font-bold" data-id="element-147">
        <div className="flex items-center gap-1.5" data-id="element-148">
          <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-149" />
          <span data-id="element-150">4.9/5 — Verified Reviews</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-151">
          <Shield className="w-4 h-4 text-brand-brown" data-id="element-152" />
          <span data-id="element-153">7-Day Guarantee — Zero Risk</span>
        </div>
      </div>
    </section>;
}